import * as types from '../../actions/actionsTypes/strumentiActionsType'
import {printOnlyInDevelopment} from "../../fanctionUtility";

export const initialStateDataOra = '';

export const dataOraReducer = (dataOra = initialStateDataOra, action) => {
  switch (action.type) {
    case types.GET_DATA_ORA:
      printOnlyInDevelopment('Current', dataOra);
      printOnlyInDevelopment('DataOra action.payload ::', action.payload);
      
      return action.payload;
    default:
      return dataOra;
  }
};


